(() => {
  const fill = () => {
    const params = new URLSearchParams(window.location.search);
    const title = (params.get('wj_product') || '').slice(0,300).replace(/[\r\n]/g,' ');
    const path = params.get('wj_product_url') || '';
    if (!title || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/[^/?#]+$/.test(path)) return;
    document.querySelectorAll('[data-wj-contact-context]').forEach(form => {
      const message = form.querySelector('textarea[name="contact[body]"]');
      if (!message || message.value.trim() || form.dataset.wjContextFilled) return;
      message.value = `${form.dataset.wjProductLabel}: ${title}\n${window.location.origin}${path}\n\n`;
      const topic = form.querySelector('select');
      if (topic && !topic.value && topic.options.length > 1) topic.selectedIndex = 1;
      form.dataset.wjContextFilled = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill, { once:true });
  else fill();
  document.addEventListener('shopify:section:load', fill);
})();
